import React from "react";
import "../css/Workout.css";

const Workout = () => {
  return (
    <div className="workout6">

      {/* ================= HERO ================= */}
      <section className="wk6-hero">
        <div className="wk6-hero-inner">
          <span className="wk6-tag">TRAINING</span>
          <h1>Workout Programs</h1>
          <p>
            Structured sessions built for performance, recovery,
            and measurable progress.
          </p>
        </div>
      </section>

      {/* ================= PROGRAM MATRIX ================= */}
      <section className="wk6-matrix">

        <div className="matrix-item">
          <h3>Strength</h3>
          <ul>
            <li>Compound lifts</li>
            <li>Progressive loading</li>
            <li>Joint-safe execution</li>
          </ul>
        </div>

        <div className="matrix-item">
          <h3>Conditioning</h3>
          <ul>
            <li>Zone-based cardio</li>
            <li>Interval protocols</li>
            <li>Fatigue control</li>
          </ul>
        </div>

        <div className="matrix-item">
          <h3>Mobility</h3>
          <ul>
            <li>Joint preparation</li>
            <li>Range expansion</li>
            <li>Active recovery</li>
          </ul>
        </div>

        <div className="matrix-item">
          <h3>Core Systems</h3>
          <ul>
            <li>Anti-rotation</li>
            <li>Stability drills</li>
            <li>Spinal integrity</li>
          </ul>
        </div>

      </section>

      {/* ================= WEEKLY SPLIT ================= */}
      <section className="wk6-week">

        <h2>Weekly Training Split</h2>

        <div className="week-grid">
          <div className="week-day">
            <span>MON</span>
            <h4>Lower Body</h4>
            <p>Squats, hinges, unilateral work</p>
          </div>

          <div className="week-day">
            <span>TUE</span>
            <h4>Upper Push</h4>
            <p>Pressing, shoulder stability</p>
          </div>

          <div className="week-day">
            <span>THU</span>
            <h4>Upper Pull</h4>
            <p>Rows, pull-ups, grip</p>
          </div>

          <div className="week-day">
            <span>SAT</span>
            <h4>Conditioning</h4>
            <p>Intervals & aerobic base</p>
          </div>
        </div>

      </section>

      {/* ================= LOAD GUIDELINES ================= */}
      <section className="wk6-guidelines">

        <h2>Training Guidelines</h2>

        <div className="guide-grid">
          <div className="guide">
            <h4>Session Length</h4>
            <p>45–70 minutes</p>
          </div>

          <div className="guide">
            <h4>Progression</h4>
            <p>Load or volume weekly</p>
          </div>

          <div className="guide">
            <h4>Rest</h4>
            <p>60–180 seconds</p>
          </div>

          <div className="guide">
            <h4>Recovery</h4>
            <p>48 hours per muscle group</p>
          </div>
        </div>

      </section>

      {/* ================= CLOSING ================= */}
      <section className="wk6-close">
        <h1>Train With Structure</h1>
        <p>No randomness. No guesswork.</p>
      </section>

    </div>
  );
};

export default Workout;
